import { Router } from '@angular/router';
import { SystemApiService } from '@wdx/clmi/api-services/services';
import { LocalStorageService } from '@wdx/shared/utils';
import { SystemSettingsService } from '@wdx/clmi/utils/services';
import { AuthenticationServiceE2e } from './authentication.e2e.service';
import { AuthenticationService } from './authentication.service';
import { ConfigService } from './config.service';

export function AuthenticationFactory(
    _router: Router,
    configService: ConfigService,
    _localStorageService: LocalStorageService,
    _systemSettingsService: SystemSettingsService,
    _systemApiService: SystemApiService,
) {
    if (configService?.config.TestMode) {
        return new AuthenticationServiceE2e();
    }

    return new AuthenticationService();
}
